import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Input, Label, FormFeedback } from 'reactstrap';
import styles from '../ProductPage.module.scss';
import { useContext } from 'react';
import { UserContext } from '../../../global/globalContext/context';
import { showMsg } from '../../../global/langs/langs';
import { useParams } from 'react-router-dom';
import { useToggle } from '../../../global/utils/hooks/useToggle';
import { postRequest } from '../../../global/utils/apiCall';
import { useState, useEffect, useRef } from 'react';
import { useOnChangeHandler } from '../../../global/utils/hooks/useOnChangeHandler';
import useAuth from '../../../global/utils/hooks/useAuth';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Toast } from 'primereact/toast';

    const REPORT_PRODUCT_URL = 'api/v1/report';

    const EMAIL_REGEX  = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

export default function Report({productName}) {
    const { lang } = useContext(UserContext);
    const { id } = useParams();
    const auth = useAuth();
    const { executeRecaptcha } = useGoogleReCaptcha();
    const toast = useRef(null);

    const [isLoading, setIsLoading] = useState(false);
    const [validEmail, setValidEmail] = useState(false);
    const [isValidDescription, setIsValidDescription] = useState(false);

    const [name, setName, onChangeHandlerName] = useOnChangeHandler('');
    const [email, setEmail, onChangeHandlerEmail] = useOnChangeHandler('');
    const [description, setDescription, onChangeHandlerDescription] = useOnChangeHandler('');


    const [modal, setModal, toggleModal] = useToggle(false);

    const showSuccess = (message) => {
        toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
    }
    const showError = (message) => {
        if(typeof(message) == 'string'){
          toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
        }
        else {
          toast.current.show(
            message.map((msg) => ({severity:'error', summary: 'Error', detail: msg, life: 5000}) )
          )
        }
      }

    const handleSendReport = async () => {
        setIsLoading(true);

        if (!executeRecaptcha) {
            showError('Execute recaptcha not yet available');
        
            return;
          }

        try{
            let recaptchaToken;

            try{
                recaptchaToken = await executeRecaptcha('report');
            }
            catch (recaptchaError) {
                showError('Recaptcha failed: ' + recaptchaError.message);
                return
            }
            const response = await postRequest(REPORT_PRODUCT_URL,{
                
                    product_id: id,
                    name:  name,
                    email: email,
                    description: description,
                    'g-recaptcha-response': recaptchaToken
                }
                );
                setIsLoading(false);
                showSuccess("Your report has been successfully registered");
                toggleModal();
                if(!auth) {
                    setName("");
                    setEmail("");
                }
                setDescription("");
        }
        catch(error){
            if (error?.response?.status === 422) {
                if(error.response.data.errors) {
                    const errors = error?.response?.data?.errors;          
                    let message = [];
                    Object.keys(errors).forEach((field) => {
                      message.push(`${field}: ${errors[field]}`);
                    });
                    showError(message);
                  } else {
                    showError(error?.response?.data?.message);
                  }
              } else if (error?.response?.status === 400) {
                setIsLoading(false);
                showError(error?.response?.data?.message) }
                else {
                setIsLoading(false);
                showError("Failed")
            }
        }
        finally{
            setIsLoading(false);
        }
    }

    useEffect(() => {
        auth &&
            setName(auth?.auth?.user);
            setEmail(auth?.auth?.userInfo?.user.email);
    },[]);

    useEffect(() => {
        setValidEmail(EMAIL_REGEX.test(email));
      },[email]);

      const handleBlur = (e) => {
        if (e.target.value.length < 20 ) {
            e.target.classList.add("is-invalid");
        } 
        else {
            setIsValidDescription(false);
            e.target.classList.remove("is-invalid");
        }
    };
    
    const handleFocus = (e) => {
        e.target.classList.remove("is-invalid");
        setIsValidDescription(false);
      }
    
  return (
    <>
        <div className='d-inline-block text-start'>
            <Toast ref={toast} position="top-center" />
        </div>
        <div 
            className={`text-center px-2 px-sm-4 my-3 ${styles.rightDivider} ${styles.report} d-inline-block`}
            onClick={toggleModal}
        >

            <Button 
                className={`
                    ${styles.actionIcon} 
                    bg-transparent 
                    border-0`}
                >
                <i className={`bi-exclamation-triangle`}>
                </i>
            </Button>
            <Modal isOpen={modal} toggle={toggleModal}>
                <ModalHeader 
                    toggle={toggleModal}
                >
                    {showMsg('report', lang)}
                </ModalHeader>
                <ModalBody>
                    <div className='mb-3'>
                        <span className='fw-bold'>
                            {showMsg('product-title', lang)}{': '}
                        </span>
                        <span>
                            {productName}
                        </span>
                    </div>
                    <Form>
                        <FormGroup floating>
                            <Input 
                                id='reporterName'
                                name='name'
                                value={name || ''}
                                type='text'
                                placeholder='Name'
                                onChange={onChangeHandlerName}
                                invalid={!name && true}
                                required
                                />
                            <Label>
                                Name
                            </Label>
                        </FormGroup>
                        <FormGroup floating>
                            <Input 
                                id='reporterEmail'
                                name='email'
                                value={email || ''}
                                type='email'
                                placeholder='Email'
                                onChange={onChangeHandlerEmail}
                                invalid = { !validEmail ? true :false }
                                required
                                />
                            <Label>
                                Email
                            </Label>
                            <FormFeedback tooltip>
                                Recipient name.<br />
                                @ symbol.<br />
                                Domain name.<br />
                                Top-level domain.
                            </FormFeedback>
                        </FormGroup>
                        <FormGroup floating>
                            <Input 
                                id='reportDescription'
                                name='description'
                                type='textarea'
                                placeholder='Description'
                                value={description}
                                onChange={onChangeHandlerDescription}
                                required
                                onFocus={handleFocus}
                                onBlur={handleBlur}
                                invalid={isValidDescription}
                                style={{height: '150px'}}
                                />
                            <Label>
                                Description
                            </Label>
                            <FormFeedback tooltip>
                                The description must be at least 20 characters long
                            </FormFeedback>
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter
                        className='border-top-0'
                >
                    <Button 
                        color="primary" 
                        className='text-white'
                        onClick={handleSendReport}
                        disabled={description.length < 20  || !name || !validEmail && true}
                        >
                        Send
                    </Button>{' '}
                    <Button color="secondary" onClick={() => {setDescription(''); toggleModal()}}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <div className={`${styles.actionTitle}`}
            >
                {showMsg('report', lang)}
            </div>
        </div>
    </>
  )
}
